import { Stack, Text } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import * as React from 'react';
export default {
  Stack,
  Text,
  SectionMessage,
  React
};